import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Spinner } from "@/components/common";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { loginGoogle } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash;
    const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sid) { navigate("/login"); return; }
    (async () => {
      try {
        await loginGoogle(sid);
        window.history.replaceState(null, "", "/app");
        navigate("/app");
      } catch (e) {
        toast.error("Accesso Google fallito. Registra prima la tua ASD.");
        navigate("/login");
      }
    })();
  }, [loginGoogle, navigate]);

  return <div className="min-h-screen grid place-items-center"><Spinner /></div>;
}
